import { getCookie } from './cookies.js';
import { Modal } from 'bootstrap';

function escapeHtml(input) {
    const value = input || '';
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

function detailUrl(template, mediaId) {
    return template.replace(/0\/$/, `${mediaId}/`);
}

function getDescriptionEditor() {
    if (!window.tinymce) {
        return null;
    }
    return window.tinymce.get('media-description');
}

function getDescriptionValue($descriptionField) {
    const editor = getDescriptionEditor();
    if (editor) {
        return editor.getContent();
    }
    return $descriptionField.val();
}

function setDescriptionValue($descriptionField, value) {
    const safeValue = value || '';
    const editor = getDescriptionEditor();
    if (editor) {
        editor.setContent(safeValue);
        return;
    }
    $descriptionField.val(safeValue);
}

function setCategoryRowEditMode($row, isEditing) {
    const $label = $row.find('.category-manage-label');
    const $input = $row.find('.category-manage-name');
    const $renameBtn = $row.find('.category-rename-btn');
    const $cancelBtn = $row.find('.category-cancel-btn');
    const $deleteBtn = $row.find('.category-delete-btn');

    if (isEditing) {
        $row.data('original-name', $label.text().trim());
        $label.addClass('d-none');
        $input.removeClass('d-none');
        $renameBtn.text('Zatwierdź').removeClass('btn-outline-primary').addClass('btn-success');
        $cancelBtn.removeClass('d-none');
        $deleteBtn.prop('disabled', true);
        $input.val($row.data('original-name'));
        $input.trigger('focus').trigger('select');
        return;
    }

    const originalName = $row.data('original-name');
    if (typeof originalName === 'string') {
        $input.val(originalName);
    }
    $input.addClass('d-none');
    $label.removeClass('d-none');
    $renameBtn.text('Zmień').removeClass('btn-success').addClass('btn-outline-primary');
    $cancelBtn.addClass('d-none');
    $deleteBtn.prop('disabled', false);
    $row.removeData('original-name');
}

$(document).ready(() => {
    const $page = $('#media-list-page');
    if ($page.length === 0) {
        return;
    }

    const canManageRaw = $page.data('can-manage');
    const canManage = canManageRaw === 1 || canManageRaw === '1' || canManageRaw === true || canManageRaw === 'true';
    const $listContainer = $('#media-list-container');
    const $emptyState = $('#media-empty-state');
    const $loadMoreWrapper = $('.list-items-load-more', $page);
    const $loadMoreButton = $loadMoreWrapper.find('button');
    const loadMoreDefaultText = $loadMoreButton.text();
    const mediaListEndpoint = window.location.pathname;
    const mediaListPageSize = 10;

    function getMediaTotalCount() {
        return parseInt($listContainer.attr('data-total-count') || '0', 10);
    }

    function setMediaTotalCount(totalCount) {
        $listContainer.attr('data-total-count', String(totalCount));
    }

    function adjustMediaTotalCount(delta) {
        const currentCount = getMediaTotalCount();
        setMediaTotalCount(Math.max(0, currentCount + delta));
    }

    function syncLoadMoreVisibility() {
        if ($loadMoreWrapper.length === 0) {
            return;
        }

        const currentCount = $listContainer.find('.media-row').length;
        const totalCount = getMediaTotalCount();

        if (currentCount < totalCount) {
            $loadMoreWrapper.removeClass('d-none');
        } else {
            $loadMoreWrapper.addClass('d-none');
        }
    }

    function loadMoreMediaOnClick() {
        if ($loadMoreWrapper.length === 0 || $loadMoreButton.length === 0) {
            return;
        }

        let isLoading = false;
        syncLoadMoreVisibility();

        $loadMoreButton.on('click', () => {
            if (isLoading) {
                return;
            }

            const currentCount = $listContainer.find('.media-row').length;
            const totalCount = getMediaTotalCount();

            if (currentCount >= totalCount) {
                syncLoadMoreVisibility();
                return;
            }

            const queryParams = new URLSearchParams(window.location.search);
            queryParams.set('offset', String(currentCount));
            queryParams.set('limit', String(mediaListPageSize));
            queryParams.set('format', 'json');

            isLoading = true;
            $loadMoreButton.prop('disabled', true).text('Ładowanie...');

            $.ajax({
                url: `${mediaListEndpoint}?${queryParams.toString()}`,
                method: 'GET',
                dataType: 'json',
                success: (response) => {
                    if (typeof response?.total_count === 'number') {
                        setMediaTotalCount(response.total_count);
                    }

                    if (Array.isArray(response?.media)) {
                        response.media.forEach((media) => {
                            upsertMediaCard(media);
                        });
                    }

                    syncLoadMoreVisibility();
                },
                complete: () => {
                    isLoading = false;
                    $loadMoreButton.prop('disabled', false).text(loadMoreDefaultText);
                },
            });
        });
    }

    loadMoreMediaOnClick();

    if (!canManage) {
        return;
    }

    const createUrl = $page.data('create-url');
    const categoryCreateUrl = $page.data('category-create-url');
    const categoryDetailTemplate = $page.data('category-detail-url-template');
    const detailTemplate = $page.data('detail-url-template');
    const csrfToken = getCookie('csrftoken');

    const $modal = $('#media-modal');
    const modalEl = $modal.get(0);
    const bsModal = modalEl ? Modal.getOrCreateInstance(modalEl) : null;
    const $form = $('#media-form');
    const $errorBox = $('#media-error-box');
    const $modalErrorBox = $('#media-modal-error-box');

    const $mediaId = $('#media-id');
    const $title = $('#media-title');
    const $url = $('#media-url');
    const $description = $('#media-description');
    const $mediaType = $('#media-type');
    const $category = $('#media-category');
    const $event = $('#media-event');
    const $pinOrder = $('#media-pin-order');
    const $filterCategory = $('#media-filter-category');
    const $saveBtn = $('#media-save-btn');
    const $modalTitle = $('#mediaModalLabel');
    const $newCategoryToggle = $('#media-new-category-toggle');
    const $newCategoryBox = $('#media-new-category-box');
    const $newCategoryName = $('#media-new-category-name');
    const $createCategoryBtn = $('#media-create-category-btn');
    const $categoryManageToggle = $('#category-manage-toggle');
    const $categoryManagePanel = $('#category-management-panel');
    const $categoryManageList = $('#category-management-list');

    function showToast(message, icon) {
        $.toast({
            text: message,
            icon,
            showHideTransition: 'slide',
            hideAfter: 3000,
            stack: 5,
            position: 'top-right',
            loaderBg: '#f96868',
        });
    }

    function showError(message) {
        const errorMessage = message || 'Wystąpił błąd.';
        const isModalVisible = $modal.length > 0 && $modal.hasClass('show');

        if (isModalVisible && $modalErrorBox.length > 0) {
            $modalErrorBox.text(errorMessage).removeClass('d-none');
            $errorBox.addClass('d-none').text('');
            return;
        }

        $errorBox.text(errorMessage).removeClass('d-none');
        $modalErrorBox.addClass('d-none').text('');
    }

    function hideError() {
        $errorBox.addClass('d-none').text('');
        $modalErrorBox.addClass('d-none').text('');
    }

    function hasUrlScheme(value) {
        return /^[a-zA-Z][a-zA-Z\d+.-]*:/.test(value);
    }

    function isValidHttpUrl(value) {
        try {
            const parsed = new URL(value);
            return (parsed.protocol === 'http:' || parsed.protocol === 'https:') && !!parsed.hostname;
        } catch (error) {
            return false;
        }
    }

    function validateUrlField() {
        const field = $url.get(0);
        if (!field) {
            return true;
        }

        const rawValue = ($url.val() || '').trim();
        if (!rawValue) {
            field.setCustomValidity('Podaj adres www.');
            return false;
        }

        const valueToValidate = hasUrlScheme(rawValue) ? rawValue : `https://${rawValue}`;
        if (!isValidHttpUrl(valueToValidate)) {
            field.setCustomValidity('Podaj poprawny adres www, np. https://example.com lub www.example.com.');
            return false;
        }

        field.setCustomValidity('');
        return true;
    }

    function getFormErrorMessage(xhr) {
        const details = String(xhr?.responseJSON?.details || '');
        if (/valid\s*url|enter\s*a\s*valid\s*url|adres\s*url|url/i.test(details)) {
            return 'Podaj poprawny adres www, np. https://example.com lub www.example.com.';
        }
        return xhr?.responseJSON?.error || 'Nie udało się zapisać materiału.';
    }

    function resetForm() {
        $mediaId.val('');
        $title.val('');
        $url.val('');
        setDescriptionValue($description, '');
        $mediaType.val('other');
        $pinOrder.val('');
        if ($event.find('option').length > 0) {
            $event.val('');
        }
        if ($category.find('option').length > 0) {
            $category.prop('selectedIndex', 0);
        }
        $newCategoryName.val('');
        $newCategoryBox.addClass('d-none');
        setBusy(false);
        $saveBtn.prop('disabled', false);
    }

    function setBusy(isBusy) {
        $saveBtn.prop('disabled', isBusy);
    }

    function hasActiveFilters() {
        const params = new URLSearchParams(window.location.search);
        const ignoredKeys = new Set(['offset', 'limit', 'format']);

        for (const [key, value] of params.entries()) {
            if (ignoredKeys.has(key)) {
                continue;
            }

            if (key === 'scope' && value === 'all') {
                continue;
            }

            if (value && value.trim() !== '') {
                return true;
            }
        }

        return false;
    }

    function validateCategoryName(name, fieldName) {
        const trimmed = (name || '').trim();
        if (!trimmed) {
            return 'Nazwa kategorii jest wymagana.';
        }
        if (trimmed.length > 120) {
            return 'Nazwa kategorii może mieć maksymalnie 120 znaków.';
        }
        return null;
    }

    function getPayload() {
        return {
            title: $title.val(),
            url: $url.val(),
            description: getDescriptionValue($description),
            media_type: $mediaType.val(),
            category_id: $category.val(),
            event_id: $event.val(),
            pin_order: $pinOrder.val(),
        };
    }

    function upsertFilterCategoryOption(category) {
        if ($filterCategory.length === 0) {
            return;
        }

        const $existing = $filterCategory.find(`option[value='${category.slug}']`);
        if ($existing.length > 0) {
            $existing.text(category.name);
        } else {
            $filterCategory.append(`<option value="${escapeHtml(category.slug)}">${escapeHtml(category.name)}</option>`);
        }
    }

    function removeFilterCategoryOptionBySlug(slug) {
        if ($filterCategory.length === 0) {
            return;
        }

        const isSelected = $filterCategory.val() === slug;
        $filterCategory.find(`option[value='${slug}']`).remove();
        if (isSelected) {
            $filterCategory.val('');
        }
    }

    function upsertModalCategoryOption(category) {
        const categoryId = String(category.id);
        const $existing = $category.find(`option[value='${categoryId}']`);

        if ($existing.length > 0) {
            $existing.text(category.name);
        } else {
            $category.append(`<option value="${categoryId}">${escapeHtml(category.name)}</option>`);
        }

        $category.val(categoryId);
    }

    function upsertCategoryOptionEverywhere(category) {
        upsertModalCategoryOption(category);
        upsertFilterCategoryOption(category);
    }

    function updateCategoryNameInVisibleRows(category) {
        const categoryId = String(category.id);
        $listContainer.find(`.media-row[data-category-id='${categoryId}'] .media-category-value`).text(category.name);
    }

    function categoryDetailUrl(categoryId) {
        return detailUrl(categoryDetailTemplate, categoryId);
    }

    function ensureCategoryManagementEmptyState() {
        const hasRows = $categoryManageList.find('.category-manage-row').length > 0;
        const $existingEmpty = $('#category-management-empty');
        if (!hasRows && $existingEmpty.length === 0) {
            $categoryManageList.append('<div class="text-muted small" id="category-management-empty">Brak kategorii.</div>');
        }
        if (hasRows) {
            $existingEmpty.remove();
        }
    }

    function upsertCategoryManagementRow(category) {
        const categoryId = String(category.id);
        const $existing = $categoryManageList.find(`.category-manage-row[data-category-id='${categoryId}']`);
        const html = category?.html;
        if (!html) {
            return;
        }

        if ($existing.length > 0) {
            $existing.replaceWith(html);
        } else {
            $categoryManageList.append(html);
        }
        ensureCategoryManagementEmptyState();
    }

    function upsertMediaCard(media) {
        const html = media?.html;
        if (!html) {
            return;
        }

        const $existing = $listContainer.find(`[data-media-id='${media.id}']`);
        if ($existing.length > 0) {
            $existing.replaceWith(html);
        } else {
            $listContainer.append(html);
        }
        sortMediaCards();
        $emptyState.addClass('d-none');
        syncLoadMoreVisibility();
    }

    function sortMediaCards() {
        const cards = $listContainer.find('.media-row').get();
        cards.sort((a, b) => {
            const aPinRaw = $(a).attr('data-pin-order');
            const bPinRaw = $(b).attr('data-pin-order');
            const aPinned = aPinRaw !== undefined && aPinRaw !== null && String(aPinRaw).trim() !== '';
            const bPinned = bPinRaw !== undefined && bPinRaw !== null && String(bPinRaw).trim() !== '';

            if (aPinned !== bPinned) {
                return aPinned ? -1 : 1;
            }

            if (aPinned && bPinned) {
                const aPin = parseInt(aPinRaw, 10);
                const bPin = parseInt(bPinRaw, 10);
                if (!Number.isNaN(aPin) && !Number.isNaN(bPin) && aPin !== bPin) {
                    return aPin - bPin;
                }
            }

            const aCreated = parseInt($(a).attr('data-created-at') || '0', 10);
            const bCreated = parseInt($(b).attr('data-created-at') || '0', 10);
            if (aCreated !== bCreated) {
                return bCreated - aCreated;
            }

            const aId = parseInt($(a).attr('data-media-id') || '0', 10);
            const bId = parseInt($(b).attr('data-media-id') || '0', 10);
            return bId - aId;
        });

        cards.forEach((card) => {
            $listContainer.append(card);
        });
    }

    function openAddModal() {
        hideError();
        resetForm();
        $saveBtn.prop('disabled', false);
        $modalTitle.text('Dodaj materiał');
        bsModal.show();
    }

    function openEditModal(button) {
        hideError();
        $mediaId.val(button.data('media-id'));
        $title.val(button.data('title'));
        $url.val(button.data('url'));
        setDescriptionValue($description, button.data('description'));
        $mediaType.val(button.data('media-type') || 'other');
        $pinOrder.val(button.data('pin-order') || '');
        $category.val(button.data('category-id'));
        $event.val(button.data('event-id') || '');
        $saveBtn.prop('disabled', false);
        $modalTitle.text('Edytuj materiał');
        bsModal.show();
    }

    $url.on('input blur', () => {
        const field = $url.get(0);
        if (!field) {
            return;
        }
        if (validateUrlField()) {
            field.setCustomValidity('');
        }
    });

    $('#media-add-btn').on('click', () => {
        openAddModal();
    });

    if ($categoryManageToggle.length > 0) {
        $categoryManageToggle.on('click', () => {
            $categoryManagePanel.toggleClass('d-none');
        });
    }

    $newCategoryToggle.on('click', () => {
        $newCategoryBox.toggleClass('d-none');
        if (!$newCategoryBox.hasClass('d-none')) {
            $newCategoryName.trigger('focus');
        }
    });

    $createCategoryBtn.on('click', () => {
        hideError();
        const name = ($newCategoryName.val() || '').trim();
        const validationError = validateCategoryName(name, 'newCategory');

        if (validationError) {
            showError(validationError);
            return;
        }

        $createCategoryBtn.prop('disabled', true);

        $.ajax({
            url: categoryCreateUrl,
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ name }),
            headers: {
                'X-CSRFToken': csrfToken,
            },
            success: (response) => {
                if (response?.category) {
                    upsertCategoryOptionEverywhere(response.category);
                    upsertCategoryManagementRow(response.category);
                    $newCategoryName.val('');
                    $newCategoryBox.addClass('d-none');
                    showToast('Dodano nową kategorię.', 'success');
                }
            },
            error: (xhr) => {
                const message = xhr?.responseJSON?.error || 'Nie udało się dodać kategorii.';
                showError(message);
            },
            complete: () => {
                $createCategoryBtn.prop('disabled', false);
            },
        });
    });

    $(document).on('click', '.media-edit-btn', function () {
        openEditModal($(this));
    });

    $(document).on('click', '.category-rename-btn', function () {
        hideError();
        const $row = $(this).closest('.category-manage-row');
        const isEditing = $row.data('editing') === true;

        if (!isEditing) {
            $row.data('editing', true);
            setCategoryRowEditMode($row, true);
            return;
        }

        const categoryId = $row.data('category-id');
        const newName = ($row.find('.category-manage-name').val() || '').trim();
        const validationError = validateCategoryName(newName, 'renameCategory');

        if (validationError) {
            showError(validationError);
            return;
        }

        const $button = $(this);
        $button.prop('disabled', true);

        $.ajax({
            url: categoryDetailUrl(categoryId),
            method: 'PATCH',
            contentType: 'application/json',
            data: JSON.stringify({ name: newName }),
            headers: {
                'X-CSRFToken': csrfToken,
            },
            success: (response) => {
                if (response?.category) {
                    $row.data('editing', false);
                    upsertCategoryOptionEverywhere(response.category);
                    upsertCategoryManagementRow(response.category);
                    updateCategoryNameInVisibleRows(response.category);
                    showToast('Zmieniono nazwę kategorii.', 'success');
                }
            },
            error: (xhr) => {
                const message = xhr?.responseJSON?.error || 'Nie udało się zmienić nazwy kategorii.';
                showError(message);
            },
            complete: () => {
                $button.prop('disabled', false);
                $row.data('editing', false);
            },
        });
    });

    $(document).on('click', '.category-cancel-btn', function () {
        hideError();
        const $row = $(this).closest('.category-manage-row');
        $row.data('editing', false);
        setCategoryRowEditMode($row, false);
    });

    $(document).on('click', '.category-delete-btn', function () {
        hideError();
        const $row = $(this).closest('.category-manage-row');
        const categoryId = $row.data('category-id');
        const categorySlug = $row.attr('data-category-slug');

        if (!window.confirm('Czy na pewno chcesz usunąć tę kategorię?')) {
            return;
        }

        const $button = $(this);
        $button.prop('disabled', true);

        $.ajax({
            url: categoryDetailUrl(categoryId),
            method: 'DELETE',
            headers: {
                'X-CSRFToken': csrfToken,
            },
            success: () => {
                $row.remove();
                $category.find(`option[value='${categoryId}']`).remove();
                if (categorySlug) {
                    removeFilterCategoryOptionBySlug(categorySlug);
                }
                if (!$category.val()) {
                    $category.prop('selectedIndex', 0);
                }
                ensureCategoryManagementEmptyState();
                showToast('Usunięto kategorię.', 'success');
            },
            error: (xhr) => {
                const message = xhr?.responseJSON?.error || 'Nie udało się usunąć kategorii.';

                if (message === 'Nie można usunąć kategorii używanej przez materiały.') {
                    showToast(message, 'error');
                    return;
                }

                showError(message);
            },
            complete: () => {
                $button.prop('disabled', false);
            },
        });
    });

    $(document).on('click', '.media-delete-btn', function () {
        hideError();
        const mediaId = $(this).data('media-id');
        if (!mediaId) {
            return;
        }
        if (!window.confirm('Czy na pewno chcesz usunąć ten materiał?')) {
            return;
        }

        $.ajax({
            url: detailUrl(detailTemplate, mediaId),
            method: 'DELETE',
            headers: {
                'X-CSRFToken': csrfToken,
            },
            success: () => {
                $listContainer.find(`[data-media-id='${mediaId}']`).remove();
                if ($listContainer.find('[data-media-id]').length === 0) {
                    $emptyState.removeClass('d-none');
                }
                adjustMediaTotalCount(-1);
                syncLoadMoreVisibility();
                showToast('Usunięto materiał.', 'success');
            },
            error: (xhr) => {
                const message = xhr?.responseJSON?.error || 'Nie udało się usunąć materiału.';
                showError(message);
            },
        });
    });

    $form.on('submit', (e) => {
        e.preventDefault();
        hideError();

        if (!$category.val()) {
            showError('Wybierz kategorię lub dodaj nową.');
            return;
        }

        const urlIsValid = validateUrlField();
        const urlField = $url.get(0);
        if (!urlIsValid) {
            if (urlField?.reportValidity) {
                urlField.reportValidity();
            }
            showError('Podaj poprawny adres www, np. https://example.com lub www.example.com.');
            return;
        }

        const mediaId = $mediaId.val();
        const isEdit = !!mediaId;
        const endpoint = isEdit ? detailUrl(detailTemplate, mediaId) : createUrl;
        const method = isEdit ? 'PATCH' : 'POST';

        setBusy(true);

        $.ajax({
            url: endpoint,
            method,
            contentType: 'application/json',
            data: JSON.stringify(getPayload()),
            headers: {
                'X-CSRFToken': csrfToken,
            },
            success: (response) => {
                if (response?.media) {
                    if (!isEdit) {
                        adjustMediaTotalCount(1);
                    }
                    upsertMediaCard(response.media);
                }
                bsModal.hide();
                resetForm();

                if (!isEdit && hasActiveFilters()) {
                    const $filterForm = $('.media-filters');
                    if ($filterForm.length > 0) {
                        $filterForm[0].reset();
                    }
                    showToast('Dodano materiał. Filtry zostały zresetowane.', 'success');
                    setTimeout(() => {
                        window.location.href = window.location.pathname;
                    }, 250);
                    return;
                }

                showToast(isEdit ? 'Zaktualizowano materiał.' : 'Dodano materiał.', 'success');
            },
            error: (xhr) => {
                const message = getFormErrorMessage(xhr);
                showError(message);
            },
            complete: () => {
                setBusy(false);
            },
        });
    });
});
